module.exports = __webpack_public_path__ + "img/stancolas-thumb.1cc73721.jpg";